import React, { Component } from 'react';
import { connect } from 'react-redux';
import Grid from 'screens/components/basic/Grid';
import { reportIRCC } from 'utils/breadcrumbInfo';
import SelectInput from 'screens/components/basic/SelectInput';
import LOOKUP from 'constants/lookup';
import moment from 'moment';
import { getToken } from 'selectors/tokenSelector';
import env from 'config/env';
import { Dialog } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import Axios from 'axios';
import fileDownload from 'js-file-download';
import { formInput } from 'actions/FormActions';
import Button from 'screens/components/basic/Button';
import { getAutomationButtons } from '../ReportAutomation/AutomationButtons';
import PlayCircleFilled from '@mui/icons-material/PlayCircleFilled';
import AutomationDrawer from '../ReportAutomation/AutomationDrawer';
import NumberInput from 'screens/components/basic/NumberInput';
import BranchSelectAutoCompleteInput from 'screens/components/basic/BranchSelectAutoCompleteInput';
import CardSimple from 'screens/components/basic/CardSimple';
import PageHeader from 'screens/components/basic/PageHeader';

const componentName = "IRCC";

const loadDialogStyle = {
    maxWidth: 'none',
    minWidth: 'none',
    zIndex: '999999999'
};

const loadDialogcustomContentStyle = {
    width: '180px',
    maxWidth: 'none'
};

const IsCannabis = [
    {
        text: "All", value: "0"
    },
    {
        text: "Cannabis", value: "1"
    },
    {
        text: "Non-Cannabis", value: "2"
    }
];

class IRCC extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: false,
            isOpenDrawer: false
        }
    }

    componentWillMount() {
        const date = new Date();
        this.props.formInput(date, `IRCCBeginDate`);
    }


    getIRCC = () => {
        this.setState({
            loading: true
        });
        let branch = this.props.selectedBranch;
        let ReportDate = this.props.beginDate ? moment(this.props.beginDate).format('YYYYMMDD') : moment().add('day').format('YYYYMMDD');
        let branchName = this.props.branchOptions.find(option => option.value === branch).label;
        let iscannabis = this.props.isCannabis ? this.props.isCannabis : "0";
        let year = this.props.year;
        let month = this.props.month;
        let token = getToken();
        let url = `reports/excel/ircc?year=${year}&month=${month}&iscannabis=${iscannabis}&branchId=${branch}`;
        let name = `${branchName}-IRCC-${ReportDate}`;

        const headers = {
            'Accept': 'application/json, text/plain, */*',
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
            'timezone_offset': new Date(Date.now()).getTimezoneOffset()
        }
        Axios.get(`${env.reportsAPIUrl()}${url}`, { headers: headers })
            .then(r => {
                this.setState({
                    loading: false
                });
                fileDownload(r.data, `${name}.csv`);
            })
            .catch(error => {
                this.setState({
                    loading: false
                });
                console.log(error);
            })
    }

    toggleDrawer = (open) => {
        if (typeof open === 'boolean') {
            this.setState({ isOpenDrawer: open });
        } else {
            this.setState((prevState) => ({ isOpenDrawer: !prevState.isOpenDrawer }));
        }
    }

    automationModel = () => {
        const { AutomationBranchIds, AutomationEmail, loggedBranch } = this.props;
        const model = {
            Email: AutomationEmail,
            BranchId: loggedBranch,
            ReportBranchIds: AutomationBranchIds || [],
            ReportId: 55,
            APIUrl: "ReportEmailAutomation/Create",
            CompanyCode: localStorage.getItem('TECHPOS_CompanyCode') || ``
        };
        return model;
    }

    render() {
        const drawerContent = getAutomationButtons("IRCCReport")({ defaultBranch: this.props.defaultBranch, branchOptions: this.props.branchOptions });
        return (
            <Grid headerContent={reportIRCC}>
                <Dialog
                    modal={true}
                    open={this.state.loading}
                    contentStyle={loadDialogcustomContentStyle}
                    style={loadDialogStyle}>
                    <div className="loading">
                        <CircularProgress size={50} />
                        <h4 className="text-center">Downloading Report</h4>
                    </div>
                </Dialog>
                <PageHeader title="Independent Retail Cannabis Collective Report"
                    description={LOOKUP.report.irccReport.description}
                />
                <CardSimple className="p-1">
                    <div className="row">
                        <div className="col-xs-12 col-sm-6 col-md-3">
                            <NumberInput
                                name={componentName + LOOKUP.report.federalReport.year.name}
                                fullWidth={true}
                                hintText={LOOKUP.report.federalReport.year.name}
                                label={LOOKUP.report.federalReport.year.label}
                                floatingLabelText={LOOKUP.report.federalReport.year.name}
                                maxLength={4}
                            />
                        </div>
                        <div className="col-xs-12 col-sm-6 col-md-3">
                            <SelectInput
                                name={componentName + LOOKUP.report.common.monthName}
                                fullWidth={true}
                                label={LOOKUP.report.common.month}
                                floatingLabelText={LOOKUP.report.common.month}
                                hintText={LOOKUP.report.common.month}
                                options={LOOKUP.report.common.monthOption}
                            />
                        </div>
                        <div className="col-xs-12 col-sm-6 col-md-3">
                            <SelectInput
                                name={componentName + "IsCannabis"}
                                fullWidth={true}
                                defaultValue="1"
                                label={"Type"}
                                floatingLabelText={"Type"}
                                hintText={"Type"}
                                options={IsCannabis && IsCannabis.length > 0 ? IsCannabis : []}
                                disabled={true}
                            />
                        </div> {/* .col */}
                        <div className="col-xs-12 col-sm-6 col-md-3">
                            <BranchSelectAutoCompleteInput
                                name={componentName + "Branch"}
                                fullWidth={true}
                                label={LOOKUP.report.common.branch}
                                floatingLabelText={LOOKUP.report.common.branch}
                                hintText={LOOKUP.report.common.branch}
                                defaultValue={this.props.loggedBranch.toString()}
                                options={this.props.branchOptions && this.props.branchOptions.length > 0 ? this.props.branchOptions : []}
                            />
                        </div>
                        <div className="col-xs-12 pt-2">
                            <Button
                                type="DownloadButton"
                                className="pull-right btnNewBrandPOS"
                                name={componentName + LOOKUP.report.common.downloadReport.name}
                                label={LOOKUP.report.common.downloadReport.label}
                                onTouchTap={() => this.getIRCC()}
                            />
                            <Button
                                type="IconInButton"
                                className="pull-right mr-1 btnNewBrandPOS"
                                name={componentName + LOOKUP.report.common.reportAutomation.name}
                                label={LOOKUP.report.common.reportAutomation.label}
                                icon={<PlayCircleFilled />}
                                onTouchTap={() => this.toggleDrawer()}
                            />
                        </div>
                        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                            <p className="purpleText"><b>Note:</b> <i>The cost in this report is calculated from <strong className="danger">Weighted Average Cost</strong>.
                                <br /> The value in this report is calculated from <strong className="danger">selling price</strong>.
                                <br /></i></p>
                        </div>
                    </div>
                </CardSimple>
                <AutomationDrawer name={"IRCC Report"} open={this.state.isOpenDrawer} toggleDrawer={this.toggleDrawer} drawerContent={drawerContent} reportModel={this.automationModel} reportId={55} headerMessage={"Note: You can schedule the monthly IRCC Report to be emailed monthly. If scheduled, reports are emailed beginning of the month"} reportName={"IRCC"} />
            </Grid>
        );
    }
}

const mapStateToProps = state => {
    let branches = state.common.userBranches || [];
    let branchOptions = [];
    branches.map((item) => {
        branchOptions.push({
            label: item.name, value: item.id.toString()
        });
    })
    let defaultBranch = [];
    defaultBranch.push({ text: state.common.branchId.toString(), value: state.common.branchId.toString() });
    return {
        year: state.form.IRCCYear,
        month: state.form.IRCCMonthOption,
        branchOptions: branchOptions,
        defaultBranch: defaultBranch,
        selectedBranch: state.form.IRCCBranch,
        IRCCBranchText: state.form.IRCCBranchText,
        loggedBranch: state.common.branchId,
        beginDate: state.form.IRCCBeginDate,
        isCannabis: state.form.IRCCIsCannabis,
        AutomationBranchIds: state.form.IRCCReportAutomationLocations || ["1"],
        AutomationEmail: state.form.IRCCReportAutomationEmail
    };
};

const mapDispatchToProps = dispatch => {
    return {
        formInput: (value, name) => dispatch(formInput(value, name))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(IRCC);
